'use client'

import Script from 'next/script'
import { useEffect } from 'react'

import { useLocalization } from '../../../../../../app/_providers/LocalizationProvider.client'
import { asyncGlobalVariable } from '../../../../../../lib/utils'

import { AffirmModalDrawer } from './AffirmModalDrawer'

// readiness observable
const affirm$ = asyncGlobalVariable(() => (globalThis.affirm?.ui ? globalThis.affirm : undefined))

export const useAffirm = ({ totalPrice }: { totalPrice: number }) => {
  useEffect(() => {
    if (globalThis.affirm?.ui) {
      globalThis.affirm.ui.ready(() => {
        globalThis.affirm.ui.refresh()
      })
      return
    }
    const sub = affirm$.subscribe(affirm => {
      affirm.ui.ready(() => {
        affirm.ui.refresh()
      })
    })
    return () => sub.unsubscribe()
  }, [totalPrice])
}

// Rendered only when the Affirm experiment is active (see `MiniCartContent` / `useAffirmExperiment`),
export const AffirmSdk = () => {
  const { locale } = useLocalization()

  const affirmApiKey = process.env.NEXT_PUBLIC_AFFIRM_API_KEY
  const affirmCdnBaseUrl = process.env.NEXT_PUBLIC_AFFIRM_CDN_BASE_URL

  if (!affirmApiKey || !affirmCdnBaseUrl) {
    return null
  }

  // Affirm docs request locale in `en_US` format
  const affirmFormattedLocale = locale.replaceAll('-', '_')

  return (
    <>
      {/* add global styles for the Affirm modal once it is shown */}
      <AffirmModalDrawer />
      <Script
        id='affirm-sdk'
        strategy='afterInteractive'
        dangerouslySetInnerHTML={{
          __html: `
              var _affirm_config = {
                  public_api_key: "${affirmApiKey}",
                  script: "${affirmCdnBaseUrl}/js/v2/affirm.js",
                  locale: "${affirmFormattedLocale}",
                  country_code: "USA",
                };

              (function(m,g,n,d,a,e,h,c){var b=m[n]||{},k=document.createElement(e),p=document.getElementsByTagName(e)[0],l=function(a,b,c){return function(){a[b]._.push([c,arguments])}};b[d]=l(b,d,"set");var f=b[d];b[a]={};b[a]._=[];f._=[];b._=[];b[a][h]=l(b,a,h);b[c]=function(){b._.push([h,arguments])};a=0;for(c="set add save post open empty reset on off trigger ready setProduct".split(" ");a<c.length;a++)f[c[a]]=l(b,d,c[a]);a=0;for(c=["get","token","url","items"];a<c.length;a++)f[c[a]]=function(){};k.async=
                !0;k.src=g[e];p.parentNode.insertBefore(k,p);delete g[e];f(g);m[n]=b})(window,_affirm_config,"affirm","checkout","ui","script","ready","jsReady");
            `,
        }}
      />
    </>
  )
}
